import type { TranslationKeys } from './en';

export const zhCN: TranslationKeys = {
  common: {
    loading: '加载中...',
    error: '错误',
    success: '成功',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    close: '关闭',
    logout: '登出',
    submit: '提交',
    back: '返回',
    retry: '重试',
    newVersion: '网站已更新到新版本。',
    reload: '刷新',
    or: '或',
  },
  login: {
    subtitleSignIn: '登录您的账户',
    subtitleSignUp: '创建账户',
    email: '邮箱',
    password: '密码',
    name: '姓名',
    signIn: '登录',
    signUp: '注册',
    working: '处理中…',
    createAccount: '创建账户',
    haveAccount: '我已有账户',
  },
  welcome: {
    greeting: '欢迎，{name}',
    signedInAs: '您已以 {email} 身份登录。',
    scaffoldNote: '这是 portal-k8s 脚手架。后续将持续迁移更多功能至此。',
    logOut: '登出',
  },
  minimaxH3: {
    navTitle: 'MiniMax H3 视频',
    title: '最强无审查视频模型 - 海螺 H3',
    description: '文字、首尾帧或参考素材输入，带原生音频的视频输出。',
    startWith: '开始方式',
    modeText: '仅文本',
    modeFrames: '首/尾帧',
    modeRefs: '参考素材',
    startFrame: '起始帧',
    endFrame: '结束帧',
    required: '必填',
    optional: '可选',
    refImages: '参考图片（最多 9 张）',
    refVideo: '参考视频（最多 1 段）',
    refAudio: '参考音频（最多 3 段）',
    clear: '清空',
    prompt: '提示词',
    promptRequired: '（必填）',
    promptPlaceholder: '描述你的视频：场景、镜头、声音与音乐，对白请用引号。',
    settings: '选项',
    aspectRatio: '宽高比',
    aspectAuto: '自动（跟随输入）',
    resolution: '分辨率',
    duration: '时长',
    qualityMode: '高画质模式',
    qualitySurcharge: '（每秒 +{credits} 积分）',
    generate: '生成',
    resultTitle: '你的视频',
    newGeneration: '新建生成',
    keyframes: '关键帧',
    keyframesHint: '把一张图片固定在片中的某个时刻。建议不超过 3 张。',
    keyframeLabel: '关键帧 {n}',
    keyframeTime: '时间（秒）',
    addKeyframe: '添加关键帧',
    removeKeyframe: '移除关键帧 {n}',
    keyframeNeedsImage: '请上传图片或移除此关键帧',
    keyframeBadTime: '请输入秒数',
    keyframeOutside: '必须在片中：大于 0 秒且小于 {max} 秒',
    keyframeSameFrame: '与关键帧 {n} 落在同一帧',
    keyframesMany: '超过 3 张关键帧可能让动作显得僵硬。',
  },
  ltxVideo: {
    navTitle: 'LTX 2.3 视频',
    title: 'LTX 2.3 视频生成',
    description: '通过文本提示生成视频，可选用起始帧（和结束帧）进行引导。',
    firstFrame: '起始帧',
    lastFrame: '结束帧（可选）',
    prompt: '提示词',
    promptPlaceholder: '描述您想生成的视频…',
    duration: '时长',
    resolution: '分辨率',
    aspectRatio: '宽高比',
    aspectLockedHint: '已锁定为起始帧比例',
    forceNsfw: '强制优化擦边内容',
    forceNsfwHint: '让整个流程针对擦边内容进行优化',
    generate: '生成',
    queuedMessage: '生成任务已排队，通常在 2–5 分钟内完成。',
    viewInHistory: '在历史记录中查看',
    newGeneration: '新建生成',
  },
  wan22Video: {
    navTitle: 'Wan 2.2 视频',
    title: 'Wan 2.2 视频生成',
    description: '文本生成视频；提供首帧时切换为图生视频。固定 5 秒时长。',
    framesTitle: '帧（可选）',
    framesDescription: '提供首帧以启用图生视频。尾帧可选。',
    firstFrame: '首帧',
    lastFrame: '尾帧',
    modeLabel: '模式',
    prompt: '提示词',
    promptPlaceholder: '描述您想生成的视频…',
    settings: '设置',
    resolution: '分辨率',
    aspectRatio: '宽高比',
    aspectLockedHint: '已锁定为起始帧比例',
    forceNsfw: '强制擦边内容',
    forceNsfwHint: '让整个流程针对擦边内容进行优化',
    generate: '生成',
    resultTitle: '结果',
    newGeneration: '新建生成',
  },
  videoAddSound: {
    navTitle: '视频添加音效',
    title: '为视频添加音效',
    description: '通过提示词为已有视频添加 AI 生成的音效与环境音。',
    inputVideo: '输入视频',
    supportedFormats: '选择视频（MP4、MOV、WebM、AVI、MKV）',
    prompt: '音效提示词',
    promptPlaceholder: '描述您想添加的声音…',
    generate: '添加音效',
    newGeneration: '新建生成',
  },
  ltxVideoExtend: {
    navTitle: '视频延长',
    title: 'LTX 视频延长',
    description: '无缝续接已有视频。上传一段视频，描述接下来应发生的内容，LTX-2.3 将生成衔接输入的新画面与音频。',
    inputVideo: '输入视频',
    supportedFormats: '选择视频（MP4、MOV、WebM、AVI、MKV）',
    prompt: '续写提示词',
    promptPlaceholder: '描述延长部分应发生的内容…',
    settings: '设置',
    modelLabel: '模型等级',
    modelStandard: '标准',
    modelPro: 'Pro',
    modelPremium: 'Premium',
    resolutionLabel: '分辨率',
    durationLabel: '延长时长',
    generate: '延长视频',
    resultTitle: '结果',
    newGeneration: '新建生成',
  },
  imageEdit: {
    navTitle: '图像编辑',
    title: '图像编辑',
    description: '基于提示词编辑一张或多张图像。请选择合适的模型。',
    modelTitle: '模型',
    model: '模型',
    aspectRatio: '宽高比',
    resolution: '分辨率',
    imagesTitle: '输入图像',
    imagesDescription: '图像 1 必填。图像 2、3 为可选，部分模型会用到。',
    image1: '图像 1',
    image2: '图像 2（可选）',
    image3: '图像 3（可选）',
    prompt: '提示词',
    promptPlaceholder: '描述您想要的编辑…',
    generate: '生成',
    resultTitle: '结果',
    newGeneration: '新建编辑',
  },
  multiAngle: {
    navTitle: '多角度视图',
    title: '多角度视图',
    description: '从不同角度生成同一张图像的多个视图——方位角、仰角与距离。',
    inputImage: '输入图像',
    angleSelection: '角度选择',
    angleHint: '留空某一维度即包含其全部选项。',
    azimuth: '方位角',
    elevation: '仰角',
    distance: '距离',
    willGenerate: '将生成约 {count} 张图像',
    generate: '生成',
    resultTitle: '结果',
    newGeneration: '新建生成',
  },
  faceSwap: {
    navTitle: '人脸替换',
    title: '人脸替换',
    description: '将参考人脸替换到基础人物图像上。上传一张基础图像和一张或多张参考人脸。',
    imagesTitle: '输入图像',
    imagesDescription: '基础人物图像和第一张参考人脸为必填。最多可再添加两张参考人脸。',
    baseImage: '基础人物图像',
    referenceFace1: '参考人脸 1',
    referenceFace2: '参考人脸 2（可选）',
    referenceFace3: '参考人脸 3（可选）',
    addExtraFaces: '添加更多参考人脸',
    hideExtraFaces: '收起额外参考人脸',
    generate: '生成',
    resultTitle: '结果',
    newGeneration: '新建人脸替换',
  },
  textToImage: {
    navTitle: '文生图',
    title: '文生图',
    description: '通过文本提示生成图像。请选择合适的模型。',
    modelTitle: '模型',
    model: '模型',
    aspectRatio: '宽高比',
    resolution: '分辨率',
    numImages: '生成数量',
    prompt: '提示词',
    promptPlaceholder: '描述您想生成的图像…',
    generate: '生成',
    resultTitle: '结果',
    newGeneration: '新建图像',
  },
  humanPortrait: {
    navTitle: '虚拟人像',
    title: '虚拟人像',
    description: '生成可作为虚拟人物基础的人像。设置外貌特征，留空即为随机。',
    outputTitle: '输出设置',
    gender: '性别',
    age: '年龄',
    aspectRatio: '宽高比',
    resolution: '分辨率',
    batchSize: '生成数量',
    characterTitle: '人物特征',
    characterHint: '默认 = 交由模型决定（不随机化）；随机 = 从列表中随机选取一个值。',
    optDefault: '默认',
    optRandomize: '🎲 随机',
    promptTitle: '附加提示词（可选）',
    promptHint: '附加到提示词开头的自由文本，例如服装、表情、场景。',
    promptPlaceholder: '例如：身穿红色连衣裙，微笑，棚拍灯光…',
    generate: '生成',
    resultTitle: '结果',
    newGeneration: '新建人像',
  },
  instagramGenerator: {
    navTitle: 'Instagram 写真',
    title: 'Instagram 写真生成',
    description: '用一张主角照片，生成任意场景的 Instagram 风格写真，同时保留其面部与身份特征。',
    mainCharacter: '主角',
    mainCharacterDescription: '上传一张人物照片。输出会保留其面部身份、发型与特征。',
    outputTitle: '输出设置',
    aspectRatio: '宽高比',
    quality: '画质',
    batchSize: '生成数量',
    prompt: '场景提示词',
    promptPlaceholder: '描述场景、姿势、服装与环境……例如：在阳光下的公园里跳舞，身穿牛仔外套',
    enrichPrompt: '丰富提示词细节',
    enrichPromptHint: '开启后，视觉模型会在生成前为你的提示词补充摄影细节（灯光、服装、氛围、构图）。',
    generate: '生成',
    resultTitle: '结果',
    newGeneration: '新建写真',
  },
  videoFaceSwap: {
    navTitle: '视频换脸',
    title: '视频换脸',
    description: '将参考照片中的头部换到视频人物身上。无需提示词——只需上传一张脸和一段视频。',
    headImage: '头部参考',
    headImageDescription: '该照片的面部与头部会被放到视频人物身上。',
    bodyVideo: '身体视频',
    bodyVideoDescription: '视频中的人物将被替换为新的头部。',
    supportedFormats: '选择视频（MP4、MOV、WebM、AVI、MKV）',
    generate: '开始换脸',
    resultTitle: '你的视频',
    newGeneration: '新建换脸',
  },
  credits: {
    navTitle: '积分',
    title: '积分',
    description: '您的积分余额与历史记录。1 积分 = $0.01。',
    balance: '余额',
    balanceUnit: '积分',
    usdEquivalent: '约 ${value} 美元',
    getMore: '充值积分',
    historyTitle: '积分历史',
    historyEmpty: '暂无积分活动。',
    historyEmptyFiltered: '该时间范围内暂无积分活动。',
    filter: {
      label: '时间范围',
      all: '全部',
      last7: '最近 7 天',
      last30: '最近 30 天',
      last90: '最近 90 天',
      custom: '自定义',
      from: '开始日期',
      to: '结束日期',
    },
    pagination: {
      rowsPerPage: '每页行数：',
      displayed: '第 {from}–{to} 条，共 {count} 条',
    },
    table: {
      when: '时间',
      reason: '原因',
      endpoint: '功能',
      delta: '变动',
      balance: '余额',
      note: '备注',
    },
    reasonLabels: {
      usage: '消费',
      refund: '退款',
      admin_grant: '赠送',
      purchase: '充值',
      adjustment: '调整',
    },
  },
  payment: {
    navTitle: '充值',
    title: '购买积分',
    description: '使用加密货币为账户充值。链上确认后自动到账。',
    packagesTitle: '选择套餐',
    customTitle: '或自定义金额',
    customLabel: '美元金额',
    customMin: '最低 $5。',
    creditsLabel: '积分',
    bestValue: '最划算',
    payButton: '加密货币支付',
    submitting: '创建订单中…',
    invoiceCreated: '正在跳转至支付页面…',
    successBanner: '感谢！付款确认后将立即到账。',
    cancelBanner: '已取消付款，未发生扣款。',
    historyTitle: '最近订单',
    historyEmpty: '暂无订单。',
    statusLabels: {
      created: '已创建',
      waiting: '等待付款',
      confirming: '确认中',
      confirmed: '已确认',
      sending: '发送中',
      partially_paid: '部分付款',
      finished: '已完成',
      failed: '失败',
      refunded: '已退款',
      expired: '已过期',
    },
    openInvoice: '打开订单',
    emailReminderTitle: '请添加邮箱以保护您的账户',
    emailReminderBody:
      '您注册时未填写邮箱。若没有邮箱，丢失访问权限后将无法找回密码。强烈建议在充值前添加并验证您的邮箱。',
    emailReminderLink: '管理账户',
  },
  changePassword: {
    navTitle: '修改密码',
    title: '修改密码',
    description: '更新您的登录密码。',
    oldPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    submit: '更新密码',
    success: '密码已更新。',
    errors: {
      mismatch: '两次输入的新密码不一致。',
      tooShort: '密码至少需要 8 个字符。',
      generic: '无法更新密码。',
    },
  },
  apiKeys: {
    navTitle: 'API 密钥',
    docsNav: 'API 文档',
    title: 'API 密钥',
    description: '密钥可让您自己的程序调用视频智能体 API。请求会像您在此处生成内容一样，从您的积分中扣费。',
    nameLabel: '密钥名称',
    namePlaceholder: '例如：生产服务器',
    create: '创建密钥',
    empty: '还没有 API 密钥。',
    createdOn: '创建于 {date}',
    lastUsed: '最近使用 {date}',
    neverUsed: '从未使用',
    usage: '已使用 {count} / {max} 个密钥',
    createdTitle: '您的新 API 密钥',
    createdBody: '请立即复制。出于安全考虑，密钥只显示这一次，之后无法再次查看。',
    keyLabel: 'API 密钥',
    copy: '复制',
    copied: '已复制',
    done: '我已复制',
    revoke: '吊销',
    revokeTitle: '吊销此密钥？',
    revokeBody: '所有使用“{name}”的程序将立即失效，且无法撤销。',
    errors: {
      load: '无法加载 API 密钥。',
      create: '无法创建密钥。',
      revoke: '无法吊销密钥。',
      limit: '您已有 {max} 个有效密钥，请先吊销一个。',
      rateLimited: '创建密钥过于频繁，请稍后再试。',
    },
  },
  recoveryEmail: {
    navTitle: '恢复邮箱',
    title: '恢复邮箱',
    description: '此邮箱用于在您忘记密码时恢复账户。修改时需要输入我们发送到新邮箱的验证码。',
    currentLabel: '当前邮箱',
    notSet: '未设置',
    currentPassword: '当前密码',
    newEmail: '新邮箱',
    sendCode: '发送验证码',
    codeSent: '验证码已发送至新邮箱。',
    codeInstructions: '请输入我们发送到 {email} 的 6 位验证码以确认更换。',
    code: '验证码',
    verify: '确认新邮箱',
    updated: '恢复邮箱已更新。',
    errors: {
      generic: '无法更新恢复邮箱。',
    },
  },
  support: {
    navTitle: '支持',
    title: '支持',
    description: '需要帮助？给我们发消息，我们会尽快回复。',
    body: '我们通常在一个工作日内回复。',
    emailButton: '发送邮件至',
  },
  videoAgent: {
    navTitle: '视频助手',
    title: '视频助手',
    intro: '你好！我是你的视频导演。告诉我你想做什么，我会帮你规划内容、把时长定准，并写出好用的提示词——每次生成前都会先给你看价格，由你确认。',
    startFromImage: '用图片生成视频',
    startFromImageHint: '上传照片或图片，让它动起来',
    startFromText: '用文字描述生成视频',
    startFromTextHint: '描述一个场景、故事或广告',
    startImagesFirst: '先生成图片',
    startImagesFirstHint: '先设计首帧，再把它做成视频',
    placeholder: '描述你的视频、粘贴脚本，或随便问我…',
    attach: '上传图片、音频或视频',
    send: '发送',
    newChat: '新对话',
    chats: '对话',
    noChats: '还没有对话',
    deleteChat: '删除对话',
    apiRun: 'API',
    apiRunReadOnly: '这个任务是通过 API 发起的，只能查看。如需继续修改，请新建对话。',
    chatActions: '对话操作',
    untitled: '新对话',
    thinking: '思考中…',
    showThinking: '查看思考过程',
    uploading: '上传中…',
    tooManyFiles: '每条消息最多可附加 {max} 个文件。',
    makingSheet: '正在拼合参考图…',
    referenceSheet: '参考拼图 · {subject}',
    references: '参考素材',
    confirm: '生成 · {credits} 积分',
    cancel: '暂不',
    editPrompt: '编辑提示词',
    hidePrompt: '收起提示词',
    writingPrompt: '正在按 MiniMax H3 官方规范编写提示词…',
    h3SkillNote: '提示词已按 MiniMax H3 官方规范（h3-prompt-writing）编写',
    duration: '时长',
    tier: '画质',
    tierQuality: '高质量',
    tierTurbo: '极速（更快）',
    confirmed: '已提交',
    dismissed: '已取消',
    rendering: '生成中…',
    queued: '排队中…',
    failed: '生成失败',
    animate: '把这张图做成视频',
    editImage: '修改这张图',
    useAsFrame: '用作首帧',
    download: '下载',
    planCheck: '时长检查：约需 {need} 秒 · 建议 {rec} 秒',
    buyCredits: '购买积分',
    error: '出错了：{error}',
    busy: '上一条消息还在处理中…',
    retry: '重试',
    retrying: '正在重试…',
    errorDetails: '详情',
    errTurn: '助手没能完成这条回复。',
    errTimeout: '助手响应超时。',
    errNetwork: '回复完成前连接中断了。',
    errSubmit: '生成任务提交失败。',
    errRejected: '视频服务拒绝了这个请求。可以直接重试，或先修改提示词。',
    errContentMinor: '内容审核未通过：提示词、上传的图片或将生成的视频可能涉及未成年人（18 岁以下）。未扣除积分。请修改方案或图片，确保所有人物都明确是成年人。',
    errContentExplicit: '内容审核未通过：提示词、上传的图片或将生成的视频被判定为色情露骨内容。未扣除积分。请修改方案或图片。',
    reviseWithAgent: '让助手修改方案',
    reviseRejected: '这个视频没有通过内容审核，请修改方案使其符合要求，然后重新给出方案。',
    errService: '生成服务出了点问题，未扣除积分，请重试。',
    errBusy: '这个对话里还有回复或提交正在进行，请稍后再试。',
    errCredits: '积分不足，无法生成。',
    errSignup: '请先注册再生成。',
    jobDone: '已完成',
    queuePosition: '排队第 {n} 位',
    etaLeft: '预计还需约 {min} 分钟',
    etaAlmost: '即将完成',
    elapsed: '已用时 {time}',
    typicalVideo: '视频通常需要 3–15 分钟',
    typicalImage: '图片通常不到一分钟',
    leaveNoteVideo: '你可以离开此页面——视频会在后台继续生成，回来时会显示在这里。',
    leaveNoteImage: '你可以离开此页面——图片会在后台继续生成，回来时会显示在这里。',
    statusUnavailable: '无法获取生成状态（{error}），请在历史记录中查看。',
    jobsRunning: '{n} 个生成中',
    jobReadyVideo: '视频已生成好',
    jobReadyImage: '图片已生成好',
    jobFailedNotice: '有一个生成失败了',
  },
  history: {
    navTitle: '历史记录',
    title: '生成历史',
    description: '您所有功能的过往生成记录。任务运行时页面会自动刷新。',
    empty: '暂无生成记录。',
    deleteConfirm: '删除该生成记录？此操作无法撤销。',
    table: {
      createdAt: '创建时间',
      feature: '功能',
      model: '模型',
      status: '状态',
      credits: '积分',
    },
    status: {
      pending: '排队中',
      processing: '生成中',
      completed: '已完成',
      failed: '失败',
    },
    detail: {
      noSelection: '选中一行以查看详情。',
      requestId: '请求 ID',
      createdAt: '创建时间',
      credits: '消耗积分',
      prompt: '提示词',
      download: '下载',
      inProgress: '任务仍在运行中，页面将自动更新。',
      retry: '重试',
      retryTooltip: '使用原始输入重新生成。上传的素材可能在 30 天后被删除，届时重试将失败。',
      retrying: '提交中…',
      retrySuccess: '已加入重试队列，请查看顶部新建行。',
      retryInputsExpired: '无法重试：原始输入已被删除（超过 30 天）。',
      rerun: '重新运行',
      rerunTooltip: '使用原始输入重新运行——将再次扣除积分。',
      remix: '调整重试…',
      remixTooltip: '打开表单并预填充原始设置，提交前不扣积分。',
      jobId: '任务',
      batchJobId: '后端任务',
      copyPrompt: '复制提示词',
      copied: '已复制！',
      originalPrompt: '原始提示词',
      enhancedPrompt: '增强提示词',
      close: '关闭',
    },
  },
  landing: {
    signIn: '登录',
    signUp: '注册',
    heroTitle: '免费无审查 AI 视频生成器',
    heroSubtitle: '以开源视频模型为核心，忠实呈现你的想象。',
    promoBanner: '🎁 免费注册即得 {signup} 积分 · 验证邮箱再得 {email} 积分',
    tabImageToVideo: '图生视频',
    tabTextToVideo: '文生视频',
    uploadLabel: '点击或拖入图片',
    uploadHint: '支持 JPEG、PNG、WebP',
    changeImage: '更换图片',
    removeImage: '移除',
    promptLabel: '提示词',
    promptPlaceholderI2v: '描述这张图片应该如何动起来…',
    promptPlaceholderT2v: '描述你想生成的视频…',
    duration: '时长',
    seconds: '{n}秒',
    generate: '生成视频',
    promptRequired: '请先写一段简短的提示词',
    imageRequired: '请先选择一张图片',
    useCasesTitle: '你想创作什么？',
    useCase1Title: '让照片动起来',
    useCase1Body: '通过图生视频，将任意图片转化为流畅逼真的动态画面。',
    useCase2Title: '凭空想象',
    useCase2Body: '输入提示词即可生成完整视频片段，无需任何素材。',
    useCase3Title: '完整创作工具箱',
    useCase3Body: '图片编辑、换脸、超分、配音等功能，一站式搞定。',
    featuresTitle: '所有创作工具',
    featuresSubtitle: '十一款生成工具，由最先进的开源模型驱动。',
    featureCta: '试一试',
    footerModels: 'LTX 2.3 与 Wan 2.2 —— 最先进的开源视频模型，即开即用。',
    footerOpenSource: '开源内核 —— 没有黑箱，基于社区模型权重构建。',
    footerUncensored: '无审查 —— 生成你真正想看的内容。',
  },
  signupNudge: {
    title: '领取免费积分',
    subtitle: '创建账号，开始生成',
    benefitSignup: '完成注册 — 获得 {credits} 免费积分',
    benefitEmail: '验证邮箱 — 再得 {credits} 积分',
    signUp: '免费注册',
    signIn: '我已有账号',
    continueWithout: '暂不注册，继续体验',
    guestWorking: '正在开通访客模式…',
    guestError: '访客模式开通失败，请重试。',
  },
  emailPromo: {
    cardTitle: '领取 {credits} 免费积分',
    cardBody: '添加并验证邮箱地址，即可领取一次性 {credits} 积分奖励。',
    emailLabel: '邮箱地址',
    sendCode: '发送验证码',
    sending: '发送中…',
    codeLabel: '验证码',
    codeHint: '请输入发送至 {email} 的 6 位验证码',
    confirm: '验证并领取',
    confirming: '验证中…',
    success: '{credits} 积分已到账！',
    alreadyClaimed: '该奖励已领取过。',
    bannerText: '验证邮箱即可获得 {credits} 免费积分',
    bannerCta: '立即领取',
    guestBannerText: '你正在以访客身份浏览 — 注册即可获得免费积分',
    guestBannerCta: '领取积分',
    errorSend: '验证码发送失败，请检查邮箱地址后重试。',
    errorVerify: '验证码无效或已过期。',
  },
  adminUsers: {
    navTitle: '用户',
    title: '用户',
    description: '所有已注册用户及其积分余额。',
    loadError: '无法加载用户列表（{status}）',
    requestFailed: '请求失败（{status}）',
    userFallback: '用户 #{id}',
    empty: '还没有用户。',
    table: {
      user: '用户',
      role: '角色',
      credits: '积分',
      jobs: '任务数',
      spent: '已消费',
      lastLogin: '最近登录',
    },
    dialog: {
      title: '调整积分',
      balance: '{who} — 当前余额 {credits} 积分',
      add: '增加',
      setTo: '设为',
      amount: '积分',
      helperAdd: '在当前余额基础上增加的积分。',
      helperSet: '新的总余额。',
      amountError: '积分数量必须是整数。',
    },
  },
  adminPricing: {
    navTitle: '定价',
    title: '定价',
    description: '各功能的积分价格。修改会在一分钟内生效（价格有短暂缓存）。',
    addPrice: '添加价格',
    any: '任意',
    empty: '还没有定价记录。',
    editCredits: '修改积分',
    delete: '删除',
    deleteConfirm: '确定删除 {endpoint} 的价格？此操作无法撤销。',
    loadError: '无法加载定价（{status}）',
    deleteFailed: '删除失败（{status}）',
    requestFailed: '请求失败（{status}）',
    table: {
      endpoint: '接口',
      model: '模型',
      resolution: '分辨率',
      duration: '时长',
      credits: '积分',
      actions: '操作',
    },
    dialog: {
      editTitle: '修改价格',
      addTitle: '添加价格',
      intro: '价格由 接口 × 模型 × 分辨率 × 时长 组合确定，用 * 表示任意。查询时优先匹配最具体的一条。此处填写的是单位基准价，部分接口会按倍数计费（按图片张数、按每 5 秒、按 num_images）。',
      endpoint: '接口',
      endpointPlaceholder: '例如：ltx-video-extend',
      endpointHelperAdd: '功能标识，例如 minimax-h3。',
      endpointHelperEdit: '如需修改键值，请删除后重新添加。',
      model: '模型',
      resolution: '分辨率',
      resolutionPlaceholder: '720p / *',
      duration: '时长',
      durationPlaceholder: '5s / *',
      credits: '积分',
      creditsHelper: '基准价（积分），1 积分 = $0.01。',
      endpointRequired: '请填写接口。',
      creditsInvalid: '积分必须是非负整数。',
    },
  },
  videoShares: {
    navTitle: '视频分享',
    title: '视频分享',
    description: '上传视频并生成可在浏览器中直接播放的公开链接。勾选多个视频可把它们排列在同一个页面上。',
    groupShare: '组合分享',
    groupShareCount: '组合分享（{count}）',
    clearSelection: '清除选择',
    shareMore: '分享更多…',
    selectAll: '全选视频',
    selectOne: '选择 {title}',
    deleteOne: '删除 {title}',
    deleteGroupOne: '删除组合 {title}',
    empty: '还没有分享任何视频。点击“分享更多…”上传视频。',
    deleteVideo: '删除上传（链接随即失效）',
    deleteVideoConfirm: '确定删除“{title}”？文件会从存储中移除，链接立即失效。',
    groupsTitle: '组合分享',
    groupsDescription: '一个页面，多个视频。',
    groupsEmpty: '还没有组合链接。勾选上方视频后点击“组合分享”。',
    deleteGroup: '删除组合链接',
    deleteGroupConfirm: '确定删除组合链接“{title}”？其中的视频仍保持分享状态。',
    videoCount: '{count} 个视频',
    videosCount: '{count} 个视频',
    layoutAuto: '自动（适应屏幕）',
    layoutAutoShort: '自动',
    perRow: '每行 {n} 个',
    copyLink: '复制链接',
    open: '打开',
    copy: '复制',
    copied: '已复制',
    linkCopied: '链接已复制',
    copyFailed: '复制失败，请手动选中链接复制',
    expired: '已过期',
    noExpiry: '永不过期',
    linkExpires: '链接有效期',
    table: {
      video: '视频',
      size: '大小',
      shared: '分享时间',
      expires: '过期',
      link: '链接',
    },
    groupTable: {
      group: '组合',
      videos: '视频',
      layout: '布局',
      created: '创建时间',
      expires: '过期',
      link: '链接',
    },
    ttl: {
      oneHour: '1 小时',
      oneDay: '1 天',
      days7: '7 天',
      days30: '30 天',
      days90: '90 天',
      never: '永不过期',
    },
    expiry: {
      never: '永不过期',
      expired: '已过期',
      inMinutes: '{n} 分钟后',
      inHours: '{n} 小时后',
      inDays: '{n} 天后',
    },
    upload: {
      title: '分享视频',
      intro: '每个文件都会生成独立的公开链接。大文件按 16 MB 分片上传，请保持此标签页打开，直到每一行都显示出链接。',
      choose: '选择视频…',
      titleLabel: '标题',
      tooLarge: '超过 {max}',
      done: '完成',
      upload: '上传',
      uploadCount: '上传 {count} 个',
    },
    group: {
      title: '组合分享',
      intro: '用一个链接把这 {count} 个视频按下方顺序排列在同一页面上。组合链接有独立的有效期；其中某个视频过期或被删除后会从页面中消失。',
      titleLabel: '标题',
      layout: '布局',
      defaultTitle: '{count} 个视频',
      done: '完成',
      create: '生成链接',
    },
  },
  sharedView: {
    linkExpires: '链接将于 {when}过期',
    sharedLink: '分享链接',
    missingTitle: '此链接不存在',
    missingBody: '请检查地址，或向分享者索取新的链接。',
    expiredTitle: '此链接已过期',
    expiredBody: '该分享已到期。请向分享者索取新的链接。',
    errorTitle: '出错了',
    requestFailed: '请求失败（{status}）',
    emptyTitle: '没有可显示的内容',
    emptyBody: '此分享中的所有视频都已过期或被删除。',
  },
};
